<template>
  <div class="reset-wrp">
    <FormList
      :list="isThirdSystem() ? infoList : userInfoList"
      :data="editData"
      :onChange="onInputChange"
      :onBlur="onBlur"
      :onFocus="onFocus"
    />
    <ButtonRow
      :firstClick="cancel"
      :secondClick="confirmChange"
      secondText="确 定"
      :loading="loading"
      :bottom="true"
      :borderRadius="true"
    />
  </div>
</template>

<script>
import {
  Row,
  Field,
  CellGroup,
  Button,
  Notify
} from 'vant'
import { accountRequest } from '@services'
import { isEmpty, localStorage } from '@utils/basicUtil'
import ButtonRow from '@components/ButtonRow'
import FormList from '@components/FormList'
export default {
  data () {
    return {
      editData: {
        trueName: '',
        phone: ''
      },
      loading: false,
      userInfoList: [
        {
          type: 'text',
          field: 'phone',
          label: '手机账号',
          placeholder: '请输入手机账号',
          readonly: true
        },
        {
          type: 'text',
          field: 'trueName',
          label: '昵称',
          placeholder: '请输入昵称'
        }
      ],
      infoList: [
        {
          type: 'text',
          field: 'trueName',
          label: '昵称',
          placeholder: '请输入昵称'
        }
      ]
    }
  },
  mounted () {
    this.getUserInfo()
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    isThirdSystem () {
      if (this.userInfo.registerFrom === '10' || this.userInfo.registerFrom === '11') { // 飞书手机端页面兼容
        return true
      }
      return false
    },
    onInputChange ({ e, field }) {
      this.editData = {
        ...this.editData,
        [field]: e
      }
    },
    onBlur ({ e, field }) {
      if (field === 'purchaserName') {
      }
    },
    onFocus ({ e, field }) {
      if (field === 'purchaserName') {
      }
    },
    async getUserInfo () {
      const info = await accountRequest.account.info({})
      if (info.success) {
        this.editData.trueName = info.result.trueName
        this.editData.phone = info.result.phone
        this.$store.commit('user/changeUserInfo', info.result)
      } else {
        Notify({ type: 'danger', message: info.message })
      }
    },
    cancel () {
      this.$router.go(-1)
    },
    async confirmChange () {
      if (!this.testField('trueName')) {
        return
      }
      const data = await accountRequest.account.updateInfo({
        realName: this.editData.trueName,
        id: this.userInfo.id
      })
      if (data.success) {
        Notify({ type: 'success', message: '修改成功' })
        // await this.refreshToken()
        localStorage.set('X-Access-Token', data.result)
        this.getUserInfo()
      } else {
        return Notify({ type: 'danger', message: data.result.message })
      }
    },
    async refreshToken () {
      const data = await accountRequest.account.refreshLogin({})
      if (data.success) {
        localStorage.set('X-Access-Token', data.result)
      }
    },
    testField (type) {
      const fieldObj = {
        trueName: '昵称'
      }
      if (isEmpty(this.editData[type])) {
        Notify({ type: 'danger', message: `请输入${fieldObj[type]}` })
        return false
      }
      return true
    }
  },
  components: {
    ButtonRow,
    [Row.name]: Row,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    FormList
  }
}
</script>

<style lang="less" scoped>
  .reset-wrp {
    width: 100%;
    min-height: 100%;
    background: #fff;
    box-sizing: border-box;
    padding-top: 15px;

    .input-field-wrapper+.input-field-wrapper {
      border-top: solid 1Px #edf2f6;
    }
    /deep/.van-field {
      padding: 25px 30px;
    }
    /deep/.van-cell--required::before {
      color: #4573DE;
    }

    .van-field__label,
    /deep/.van-field__label {
      width: 200px;
      font-size:30px;
      font-weight:500;
      color:rgba(51,51,51,1);
    }
    /deep/ .van-field__control {
      color: #999;
      text-align: right;
    }
    .code-wrp{
      position: relative;
      border-top: 1PX solid #edf2f6;
      border-bottom: 1PX solid #edf2f6;
      box-sizing: border-box;
    }
    .get-code {
      width: 180px;
      height: 54px;
      font-size: 24px;
      border-radius: 5px;
      position: absolute;
      left: 40%;
      top: 50%;
      transform: translateY(-50%);
      border: 0;
    }

  }
</style>
